import { Component, ViewChild, ElementRef, Input } from "@angular/core";
import { DataService } from "../../services/data/data.service";
import { TradeLines } from "../../interfaces/service.response";
import { WorkspaceServiceService } from "../../services/workspace-service.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AccountWS } from "../../model/account.data";
import { ICurrencyFormatter, Currencyformatters } from "../../interfaces/ICurrencyFormatters";
import { Account } from "../../api/DixApiClient";
import { GlobalGridModeService } from "./../../services/globalGridMode/globalGridMode.service";

import * as $ from "jquery";
import { SymbolTypeEnum } from "../../enums/SymbolType.enum";
import { allowedForexSymbols } from "../../model/box.quote.data";
import { filter } from "rxjs/operators";
import { AccountProvider } from "../../model/workspace.data";
import { Providers } from "../../enums/providers";
@Component({
    selector: "user-select",
    template: require('./userSelect.component.html'),
    styles: [require('./userSelect.component.css')]
})
export class userSelect {
    profitLoss: number = 999999.99;
    balance: number = 0;
    marginInUse: number = 0;
    sumOfPips: number = 0;

    @Input() public isMobileBalance: boolean = false;

    private _sumOfUplUsd: number = 0;
    public get sumOfUplUsd(): number {
        return this._sumOfUplUsd;
    }
    public set sumOfUplUsd(value: number) {
        this._sumOfUplUsd = value;
    }

    sumOfPipsHistory: number = 0;

    private _sumOfPlUsdHistory: number = 0;
    public get sumOfPlUsdHistory(): number {
        //   console.log("[this._sumOfPlUsdHistory,this.workspaceService.data.sumOfUplUsd]");
        //   console.log([this._sumOfPlUsdHistory,this.workspaceService.data.sumOfUplUsd]);
        return this._sumOfPlUsdHistory; //this._sumOfPlUsdHistory + this.workspaceService.data.sumOfUplUsd;
    }
    public set sumOfPlUsdHistory(value: number) {
        this._sumOfPlUsdHistory = value;
    }

    @ViewChild("userSelectContainer")
    userSelectContainer?: ElementRef;

    set accounts(v) {}

    get accounts() {
        return this.workspaceService.data.accounts;
    }

    get tournamentAccount() {
        return this.workspaceService.data.allTournamentsAccounts;
    }

    get liveAccount(): boolean {
        return this.dataService.LiveAccount;
    }

    get activeAccountId() {
        return this.workspaceService.data.activeAccountId;
    }

    get unactiveAccounts() {
        if (this.workspaceService.data.afterChallengeUsers.length > 0) {
            return this.accounts
                .filter(a => a.id != this.activeAccountId)
                .filter(v => {
                    return this.workspaceService.data.afterChallengeUsers.indexOf(v.id) == -1;
                });
        }

        return this.accounts.filter(a => a.id != this.activeAccountId);
    }

    get activeAccount() {
        let findAccount = this.accounts.find(a => a.id == this.activeAccountId);

        if (findAccount === undefined) {
            findAccount = this.accounts.find(a => a.id == this.workspaceService.data.mainAccountId);
        }

        return findAccount; //this.accounts.find(a => a.Id == this.activeAccountId)
    }

    get activeAccountType() {
        //     if(this.workspaceService.data.competitionAccountList.indexOf(this.workspaceService.data.activeAccountIdBySet)>-1)
        //     {
        //         return this.workspaceService.data.tournamentWithActiveAccountId[0].shortName;
        //     }

        //    let active =  this.tournamentAccount.filter(v=>{
        //         return v.accountId == this.workspaceService.data.activeAccountIdBySet
        //     })[0];

        //     if(active!==undefined)
        //     {
        //         if(active.tournament!==undefined && active.tournament!=null)
        //         {
        //             return active.tournament.shortName;
        //         }
        //     }

        return this.getAccountTypeById(this.workspaceService.data.activeAccountIdBySet);
    }

    public get getProviderAccountId() {
        return this.workspaceService.data.accountIdForProvider;
    }

    public get currentProvider() {
        return this.workspaceService.data.currentProvider;
    }

    public get accountCurrency() {
        return this.workspaceService.data.currentAccountCurrencyCode;
    }

    public getAccountTypeById(id: number) {
        let active = this.tournamentAccount.filter(v => {
            return v.accountId == id;
        })[0];

        if (active !== undefined && this.workspaceService.data.currentProvider != "OANDA") {
            if (active.tournament !== undefined && active.tournament != null) {
                return active.tournament.shortName;
            }
        }

        if (this.workspaceService.data.currentProvider == Providers.OANDA) {
            return "OANDA";
        }

        if (this.workspaceService.data.currentProvider == Providers.GAIN) {
            return "GAIN";
        }

        return "DEMO";
    }

    switchAccount(account: Account) {
        if (this.workspaceService.data.currentProvider == "OANDA") {
            let AccountID = (this.workspaceService.data.accounts as AccountProvider[]).filter(v => {
                return v.id == account.id;
            })[0].accountProviderId;

            this.dataService.sendRequest({
                Cmd: DataService.TYPE_SWITCHACCOUNT,
                Data: {
                    AccountId: AccountID,
                    Provider: this.workspaceService.data.currentProvider,
                    AccountID: AccountID
                }
            });
        } else {
            this.dataService.sendRequest({
                Cmd: DataService.TYPE_SWITCHACCOUNT,
                Data: {
                    AccountId: account.id,
                    Provider: this.workspaceService.data.currentProvider,
                    AccountID: account.id
                }
            });
        }

        this.workspaceService.data.activeAccountIdBySet = account.id;

        if (this.workspaceService.data.tournamentsWithUser) {
            let selectedTournament = this.workspaceService.data.tournamentsWithUser.filter(v => {
                return v.accountId == account.id;
            });
            if (selectedTournament[0] != undefined) {
                let selectedPullTournament = this.workspaceService.data.currentTournaments.filter(v => {
                    return v.id == selectedTournament[0].id;
                });

                if (selectedPullTournament[0] != undefined) {
                    if (selectedPullTournament[0].symbolList && selectedPullTournament[0].symbolList.symbolListSymbol) {
                        let symbols = selectedPullTournament[0].symbolList.symbolListSymbol.map(v => {
                            return v.symbol;
                        });

                        this.workspaceService.data.allowedForexSymbols = symbols as string[];
                        //   debugger;
                        console.log(symbols);
                    }
                }
            }
        }

        this.workspaceService.data.globaGridMode.changeActiveBasket.next(this.workspaceService.data.activeBasket);
    }

    public formatters: ICurrencyFormatter = Currencyformatters;
    private _currency = "USD";
    public get currency() {
        if (this.workspaceService.data.currentAccountCurrencyCode) {
            return this.workspaceService.data.currentAccountCurrencyCode;
        } else {
            return "USD";
        }
    }

    public get currentCurrency() {
        return this.workspaceService.data.currentAccountCurrencyCode;
    }

    public get sumOfPlUsdHistoryFormatted(): string {
        return this.formatters[this.currency].format(this.sumOfPlUsdHistory);
    }

    public get balanceFormatted(): string {
        return this.formatters[this.currency].format(this.balance);
    }

    public AccountBalanceFormatted(v: number): string {
        return this.formatters[this.currency].format(v);
    }

    public get accountValFormatted(): string {
        return this.formatters[this.currency].format(this.accountVal);
    }

    private _accountVal: number = 0;
    public get accountVal(): number {
        return this._accountVal;
    }
    public set accountVal(value: number) {
        this._accountVal = value;
    }

    constructor(
        private dataService: DataService,
        private workspaceService: WorkspaceServiceService,
        private modalService: NgbModal,
        private globalGridMode: GlobalGridModeService
    ) {
        this.dataService.dataSubscriber.subscribe(response => {
            if (response) {
                switch (response.Type) {
                    case "SwitchProviderRs":
                        this.balance = 0;
                        this.marginInUse = 0;

                        this.sumOfPips = 0;
                        this.sumOfUplUsd = 0;

                        this.marginInUse = 0;
                        this.sumOfPips = 0;
                        this.sumOfUplUsd = 0;
                        this.profitLoss = 0;
                        this.sumOfPipsHistory = 0;
                        this.sumOfPlUsdHistory = 0;
                        this.accountVal = 0;
                        this.workspaceService.data.sumOfUplUsd = 0;
                        break;
                    case "TradeLines":
                        var trendLines: TradeLines = <TradeLines>response;
                        if (trendLines.MoneyLine) {
                            this.balance = trendLines.MoneyLine.Balance || 0;
                            this.marginInUse = trendLines.MoneyLine.MarginInUse || 0;
                            this.sumOfPips = trendLines.MoneyLine.SumOfPips || 0;
                            this.sumOfUplUsd = trendLines.MoneyLine.SumOfUPLUSD || 0;
                            this.profitLoss = trendLines.MoneyLine.PnL || 0;
                            this.sumOfPipsHistory = trendLines.MoneyLine.SumOfPipsHistory || 0;
                            //   this.sumOfPlUsdHistory = this.sumOfUplUsd + this.profitLoss;                    //trendLines.MoneyLine.SumOfPLUSDHistory || 0;
                            this.sumOfPlUsdHistory = trendLines.MoneyLine.SumOfPLUSDHistory || 0;
                            this.accountVal = trendLines.MoneyLine.AccountValue || 0;
                            this.workspaceService.data.sumOfUplUsd = this.sumOfUplUsd;
                            //  this.sumOfPlUsdHistory = this.sumOfPlUsdHistory + this.sumOfUplUsd;

                            if (this.activeAccount !== undefined) {
                                this.workspaceService.data.currentAccountInformation = {
                                    id: this.activeAccount.id,
                                    name: this.activeAccount.accountName
                                };
                            }

                            this.workspaceService.data.currentAccountMoneyLine = trendLines.MoneyLine;
                        }
                }
            }
        });

        //     this.dataService.dataSubscriber.subscribe(response => {
        //         if(response.Type=="RenameAccountRs" || response.Type=="CreateAccountRs"  || response.Type=="DeleteAccountRs")
        //         {
        //            // this.closeWindow();
        //            console.log("USERSIGNAL");
        //         }
        //    })

        this.workspaceService.data.globaGridMode.activeAccountIdBySetSubscriber.subscribe(v => {
            this.workspaceService.data.globaGridMode.changeActiveBasket.next(this.workspaceService.data.activeBasket);

            if (this.workspaceService.data.activeAccountId != this.workspaceService.data.activeAccountIdBySet) {
                this.workspaceService.data.activeAccountId = this.workspaceService.data.activeAccountIdBySet;

                if (
                    this.activeAccount !==
                    undefined /*&& this.activeAccount.id!=this.workspaceService.data.activeAccountId*/
                ) {
                    this.switchAccount(this.activeAccount);

                    if (
                        this.workspaceService.data.competitionAccountList.indexOf(
                            this.workspaceService.data.activeAccountIdBySet
                        ) > -1
                    ) {
                        //  debugger;
                        //   this.workspaceService.data.sy
                        //    this.workspaceService.data.activeSymbolType = SymbolTypeEnum.Forex;
                        // const firstBox = this.workspaceService.data.boxes.find(b => b.searchVisible && b.visible);
                        // if(firstBox)
                        // {
                        //     console.log("EMITUSER");
                        //     this.globalGridMode.emitSymbolChanged({ symbol: firstBox!.Symbol, overrideLockAllCharts: true , refreshperiod:true});
                        // }
                    } else {
                    }
                }
            }
        });
    }

    private _readData: boolean = false;
    public get readData(): boolean {
        return this._readData;
    }
    public set readData(value: boolean) {
        this._readData = value;
    }

    public get providerWithoutAccounts(): boolean {
        if (this.accounts.length == 0) {
            return true;
        }

        return this.workspaceService.data.providerWithoutAccounts;
    }

    public updateUserListAction() {
        if (
            this.workspaceService.data.currentProvider == Providers.OANDA ||
            this.workspaceService.data.currentProvider == Providers.GAIN
        ) {
            return;
        }

        this.openSelect = !this.openSelect;
        this.readData = true;
        //  (<any>$('.userSelect')).dropdown("hide");

        this.refreshUserList();
    }

    private _openSelect: boolean = false;
    public get openSelect(): boolean {
        return this._openSelect;
    }
    public set openSelect(value: boolean) {
        this._openSelect = value;
    }

    public refreshUserList() {
        this.workspaceService.data
            .loadAccounts(this.workspaceService.data.userName)
            .then(response => {
                //console.log(response);
                if (response !== null) {
                    if (this.workspaceService.data.mapUnactiveChallengeUsers.length > 0) {
                        this.workspaceService.data.accounts = response.filter(v => {
                            return this.workspaceService.data.mapUnactiveChallengeUsers.indexOf(v.id) < 0;
                            // return true;
                        });
                    } else {
                        this.workspaceService.data.accounts = response;
                    }

                    console.log("DEMOACCOUNTS");
                    console.log(response);
                    this.readData = false;

                    //  if(this.userSelectContainer!==undefined)
                    //    {
                    // (<any>$('.userSelect')).dropdown("hide");
                    //      (<any>$('.userSelect')).dropdown("show");

                    //       }
                }
            })
            .catch(error => {
                console.error(error);
                this.readData = false;
            });
    }

    public get debugVisibility() {
        return this.dataService.DebugVisibility;
    }

    public trackItem(index: number, item: Account) {
        return item.id;
    }

    public allowedForexSymbols = [
        "AUD/CAD",
        "AUD/JPY",
        "AUD/NZD",
        "AUD/USD",
        "AUD/CHF",
        "CAD/JPY",
        "CAD/CHF",
        "CHF/JPY",
        "EUR/AUD",
        "EUR/CAD",
        "EUR/CHF",
        "EUR/GBP",
        "EUR/JPY",
        "EUR/NZD",
        "EUR/USD",
        "GBP/CHF",
        "GBP/JPY",
        "GBP/USD",
        "GBP/AUD",
        "GBP/CAD",
        "GBP/NZD",
        "NZD/JPY",
        "NZD/USD",
        "NZD/CAD",
        "NZD/CHF",
        "USD/CAD",
        "USD/CHF",
        "USD/JPY",
        "TRY/JPY"
    ];
}
